import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=94500622&scoped=true"
import script from "./AlertError.vue?vue&type=script&lang=js"
export * from "./AlertError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94500622",
  null
  
)

export default component.exports